import storage from "./storage.js";
import events from "./event.js";

const CONTEXT_WHITELIST = [
    /\/products\/product\.\d+\./, // PDP
    /\w+\.(test)?\.?mynuskin\.com/, // MySite
    /cart\.(\w+\.)?html/, // cart
    /checkout\.(\w+\.)?html/, // checkout
    /sign-up\/shopper-member/, // member sign up
    /shopper-account\./, // guest signup
    /\/personal-offer\./, // personal offer
    /\/static\//, // all static apps
    /\/exclusive-offer\./, // leader preview
    /\/catalog\//, // catalog/PDP3
    /\w+\.(test)?\.?nuskin\.io/ // AEM Feature Branch
];
/**
 *
 * Saves the shoppingContext to localStorage
 *
 * @namespace ShoppingContext
 */
"use strict";

const STORAGE_KEY = storage.metadata.SHOPPING_CONTEXT;

// ---------------------------------------------
//
//            Define public methods
//
// ---------------------------------------------
const ShoppingContext = {
    STOREFRONT: 'storefront',
    PERSONAL_OFFER: 'personal_offer',
    PRODUCT_OFFER: 'product_offer',
    SKIN_CONSULT: 'skin_consult',
    CONNECT: 'nuskin_connect',
    MOBILE_CONSUMER: 'mobile_consumer',
    MOBILE_AFFILIATE: 'mobile_affiliate',

    clearShoppingContext: () => {
        ShoppingContext.setShoppingContext(null);
    },
    /**
     * returns shoppingContext from localStorage
     *
     * @returns {Object}
     * {
     *     context: 'storefront',
     *     overrides: {
     *         showWholesale: true
     *     }
     * }
     */
    getShoppingContext: () => {
        const url = window.location.href;
        const keepContext = CONTEXT_WHITELIST.find(exp => url.match(exp));
        let context = JSON.parse(window.localStorage.getItem('shoppingContext')) ? JSON.parse(window.localStorage.getItem('shoppingContext')).context : null
        if (!keepContext && context !== 'skin_consult') ShoppingContext.clearShoppingContext();
        return storage.getItem(STORAGE_KEY);
    },

    setShoppingContext: (context, overrides) => {
        let shoppingContext;
        if (context == null || typeof (context) == 'undefined') {
            storage.removeItem(STORAGE_KEY);
        } else {
            shoppingContext = {context: context};
            if (overrides) {
                shoppingContext.overrides = overrides;
            }
            storage.setItem(STORAGE_KEY, shoppingContext);
            events.publish(events.shop.SET_SHOPPING_CONTEXT, shoppingContext);
        }
        return shoppingContext;
    },

    isContext: context => {
        let ctxt = ShoppingContext.getShoppingContext()
        if (ctxt && ctxt.context) {
            return context === ctxt.context
        }
        return false
    }
};

export default ShoppingContext;
